



























import { Component, Prop, Vue } from 'vue-property-decorator';
import { RateRuleAmountFilter, RateRuleAmountModel, RateRuleEnum } from '@/services/api/nswag/stapiclient_generated';
import { UserStore } from '@/store/user-module';
import StCurrencyInput from '@/components/basic/StCurrencyInput.vue';
import { stRateRuleApi } from '@/services/st-api';

@Component({
  components: {
    StCurrencyInput,
  },
})
export default class StRatePicker extends Vue {
  @Prop() value!: RateRuleAmountModel;
  @Prop() label!: string;
  @Prop() inputClass!: string;
  @Prop() rateRuleAmountFilter!: RateRuleAmountFilter;
  @Prop() projectRuleAmount!: RateRuleAmountModel;
  @Prop() disabled!: boolean;

  get useRateRules() {
    return UserStore.userSettings.useRateRules;
  }

  get finalAmount() {
    return this.projectRuleAmount?.amount ?? this.amountModel.amount;
  }

  get finalSource() {
    if (!!this.projectRuleAmount) {
      if (this.projectRuleAmount.overrideAmount) {
        return RateRuleEnum.Project;
      } else {
        return this.projectRuleAmount.sourceRule;
      }
    }

    return this.amountModel.sourceRule;
  }

  async setOverrideAmountFalse() {
    let filter = RateRuleAmountFilter.fromJS(this.rateRuleAmountFilter);

    if (filter.projectTaskId || filter.projectTaskId == 0) {
      filter.projectTaskId = undefined;
    } else if (filter.projectId || filter.projectId == 0) {
      filter.projectId = undefined;
    } else if (filter.customerId || filter.customerId == 0) {
      filter.customerId = undefined;
    }

    let res = await stRateRuleApi.getCustomerProjectRateRuleAmount(filter);
    res.overrideAmount = false;
    this.amountModel = res;
  }

  get amountModel() {
    return this.value;
  }

  set amountModel(data: RateRuleAmountModel) {
    if (data) {
      this.$emit('input', data);
    }
  }
}
